<template>
  <div class="d-flex flex-column flex-md-row">
    <div class="flex-grow-1 overflow-hidden">
      <div
        class="text-nowrap text-truncate"
        :class="{ 'font-weight-bolder': displayName, 'text-muted': !displayName }"
        style="font-size: 1rem"
      >
        <span v-if="item.is_incoming && !item.receiver_viewed_at_time" class="mr-2 text-info">&bull;</span>
        <font-awesome-icon v-if="isSnoozed" :icon="['far', 'clock']" size="sm" class="mr-1 text-hint" title="Snoozed" />
        {{ displayName || 'Draft' }}
      </div>
      <div class="text-muted text-overflow mt-1">
        <i class="text-hint" style="font-weight: normal">{{ item.is_incoming ? 'From' : 'To' }}:</i>&nbsp;{{
          item.is_incoming ? sender : item.doctor
        }}
      </div>
      <div class="text-muted text-overflow" style="font-weight: 500">
        <span v-if="isExample" class="badge badge-warning">Test Referral</span>
        {{ item.is_incoming ? item.practice.name : (item.to_practice && item.to_practice.name) || '-' }}
      </div>
    </div>
    <div class="text-right">
      <div class="font-weight-bold text-nowrap">{{ displayTime }}</div>
      <from-now class="text-muted mt-1 d-block text-nowrap" :time="time" />
      <div v-if="badge" class="badge badge-primary">{{ badge }}</div>
      <div v-else-if="item.sent_time" class="status-indicator-sm">
        <span :class="step > 0 ? 'bg-primary' : 'bg-light'"></span>
        <span :class="step > 1 ? 'bg-primary' : 'bg-light'"></span>
        <span :class="step > 2 ? 'bg-primary' : 'bg-light'"></span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.now = moment().utc()
  },
  computed: {
    ...mapGetters('settings', ['DemoId']),
    displayName() {
      return `${this.item.patient_firstname || ''} ${this.item.patient_lastname || ''}`.trim()
    },
    sender() {
      return `Dr. ${this.item.referring_doctor?.first_name || ''} ${this.item.referring_doctor?.last_name || ''}`
    },
    time() {
      return moment(this.item.sent_time || this.item.updated_at)
    },
    displayTime() {
      return this.time.format('ll')
    },
    badge() {
      if (!this.item.sent_time) return this.item.cancelled_time ? '' : 'draft'
      else if (this.item.is_incoming && !this.item.receiver_viewed_at_time) return 'new'
      return ''
    },
    step() {
      if (this.item.completed_time) return 3
      if (this.item.is_marked_scheduled) return 2
      // if (this.item.patient_called_on) return 2
      if (this.item.receiver_viewed_at_time) return 1
      // if (this.item.sent_time) return 1
      return 0
    },
    isSnoozed() {
      return this.$helpers.isArchived(this.item)
    },
    elapsedTime() {
      if (this.step != 1) return
      try {
        return moment.duration(this.now.diff(this.item.receiver_viewed_at_time || this.item.sent_time)).asMilliseconds()
      } catch (e) {
        console.error(e)
        this.$exception(e)
      }
    },
    stepClass() {
      if (this.item.is_incoming) {
        if (this.elapsedTime > 48 * 36e5) return 'bg-info'
        if (this.elapsedTime > 96 * 36e5) return 'bg-danger'
      }
      return 'bg-primary'
    },
    isExample() {
      return !this.item.is_incoming && this.item.to_practice?.id == this.DemoId
    },
  },
}
</script>

<style lang="scss" scoped>
.status-indicator-sm {
  span {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    border: 1px solid var(--border-color);
    background: var(--light-color);
    display: inline-block;
    margin: 0 3px;

    &.bg-primary {
      border: var(--primary-color);
    }

    &.bg-info {
    }

    &.bg-danger {
    }
  }
}
.badge-primary {
  color: var(--primary-color);
  background-color: var(--primary-color-20);
  padding: 0.175rem 0.25rem;
  // font-weight: bold;
}
</style>